import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RoundedCurrencyPipe, UtilsModule } from '@innogy/utils-deprecated';
import { JssModule, TextField } from '@sitecore-jss/sitecore-jss-angular';

@Component({
  selector: 'ed-order-overview-cost',
  templateUrl: './order-overview-cost.component.html',
  styleUrls: ['./order-overview-cost.component.scss'],
  standalone: true,
  imports: [CommonModule, JssModule, UtilsModule],
  providers: [RoundedCurrencyPipe],
})
export class OrderOverviewCostComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() label?: TextField;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() beforeDiscountCost?: number;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() cost?: number;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() flexDirection: 'flex-column' | 'flex-row' = 'flex-row';
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() hasDiscount = false;
}
